import { Localized } from "@fluent/react"
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { useAppSelector } from "../../../../app/hooks"
import { docDeviationsSelectors } from "../../documentSlice"
import { ClassificationChip, StatusChip } from "./Utils"
import LaunchIcon from '@mui/icons-material/Launch'

export const DeviationsList = (props: { open: (id: number) => void }) => {
    const deviations = useAppSelector(state => docDeviationsSelectors.selectAll(state))

    return <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Table size="small" stickyHeader>
            <TableHead>
                <TableRow>
                    <TableCell><b>Nr odchylenia</b></TableCell>
                    <TableCell width={220}>
                        <b>Status</b>
                    </TableCell>
                    <TableCell width={220}>
                        <b>Klasyfikacja</b>
                    </TableCell>
                    <TableCell width={140} align="right" />
                </TableRow>
            </TableHead>
            <TableBody>
                {deviations.map(d => <TableRow>
                    <TableCell>{`Odchylenie ${d.order}`}</TableCell>
                    <TableCell><StatusChip status={d.status} /></TableCell>
                    <TableCell>
                        <ClassificationChip value={d.classification} />
                    </TableCell>
                    <TableCell width={140} align="right">
                        <Button startIcon={<LaunchIcon />} size='small' onClick={() => props.open(d.id)}>
                            <Localized id='open'>Otwórz</Localized>
                        </Button>
                    </TableCell>
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer>
}
